import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {

        sex: '',
        employment: '',
        why: '',
        age: '',
        answers: [],
        lotsAlcohols: [],
        littleAlcohols: [],
        otherAlcohols: [],
        calendar: [],
        //nb of pts
        total: 0,
        alcoholPoints: 0,
        resultsUrl: '',
        saveDb: true,

    },
    mutations: {
        setSex(state, payload) {
            state.sex = payload.sex;
        },
        setEmployment(state, payload) {
            state.employment = payload.employment;
        },
        setWhy(state, payload) {
            state.why = payload.why;
        },
        setAge(state, payload) {
            state.age = payload.age;
        },
        setAnswers(state, payload) {
            state.answers = payload.answers;
        },
        setLotsAlcohols(state, payload) {
            state.lotsAlcohols = payload.lotsAlcohols;
        },
        setLittleAlcohols(state, payload) {
            state.littleAlcohols = payload.littleAlcohols;
        },
        setOtherAlcohols(state, payload) {
            state.otherAlcohols = payload.otherAlcohols;
        },
        setCalendar(state, payload) {
            state.calendar = payload.calendar;
        },
        setTotal(state, payload) {
            state.total = payload.total;
        },
        setAlcoholPoints(state, payload) {
            state.alcoholPoints = payload.alcoholPoints;
        },
        setResultsUrl(state, payload) {
            state.resultsUrl = payload.resultsUrl;
        },
        setSaveDb(state, payload) {
            state.saveDb = payload.saveDb
        },
    },
    getters: {

        // get breadcrumbs
        getSex: state => {
            return state.sex
        },
        // get breadcrumbs
        getAge: state => {
            return state.age
        },
        getEmployment: state => {
            return state.employment
        },
        getWhy: state => {
            return state.why
        },
        getLotsAlcohols: state => {
            return state.lotsAlcohols
        },
        getLittleAlcohols: state => {
            return state.littleAlcohols
        },
        getOtherAlcohols: state => {
            return state.otherAlcohols
        },
        averageGrams: state => {
            return (state.lotsAlcohols + state.littleAlcohols + state.otherAlcohols) / 4;
          },
        mostGrams: state => {
            return Math.max(state.lotsAlcohols, state.littleAlcohols, state.otherAlcohols);
        },
        getCalendar: state => {
            return state.calendar
        },
        averageDays: state => {
            if (Array.isArray(state.calendar)) {
                return state.calendar.filter((day) => day.alcohol > 0)
                  .length / 4;
            } else {
            return 0;
            }
          },
        getAnswers: state => {
            return state.answers
        },
        getTotal: state => {
            return state.total
        },
        getAlcoholPoints: state => {
            return state.alcoholPoints
        },
        getResultsUrl: state => {
            return state.resultsUrl
        },

        getSaveDb: state => {
            return state.saveDb
        },
        

    }
});